(() => {
  if (window.iconWithTextPopupLoaded) return;
  window.iconWithTextPopupLoaded = true;

  const openSelector = '[data-icon-with-text-popup-open]';
  const closeSelector = '[data-icon-with-text-popup-close]';
  let activePopup = null;
  let activeTrigger = null;

  const focusDialog = (popup) => {
    const dialog = popup.querySelector('[role="dialog"]');
    if (dialog) {
      dialog.focus();
    }
  };

  const openPopup = (trigger) => {
    const popup = document.getElementById(trigger.dataset.iconWithTextPopupOpen);
    if (!popup) return;

    activePopup = popup;
    activeTrigger = trigger;
    popup.hidden = false;
    document.documentElement.classList.add('overflow-hidden');
    requestAnimationFrame(() => focusDialog(popup));
  };

  const closePopup = () => {
    if (!activePopup) return;

    activePopup.hidden = true;
    document.documentElement.classList.remove('overflow-hidden');

    if (activeTrigger) {
      activeTrigger.focus();
    }

    activePopup = null;
    activeTrigger = null;
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(openSelector);
    if (trigger) {
      openPopup(trigger);
      return;
    }

    if (event.target.closest(closeSelector)) {
      closePopup();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closePopup();
    }
  });
})();
